import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { StageBucket } from "@colab/shared";

// Themed fill for known legacy stage keys; arbitrary HubSpot stage IDs fall
// back to the neutral accent. Kept in sync with the admin /analytics chart.
const FILL: Record<string, string> = {
  submitted: "hsl(var(--status-submitted))",
  under_review: "hsl(var(--status-review))",
  approved: "hsl(var(--status-approved))",
  active: "hsl(var(--status-active))",
  closed_won: "hsl(var(--status-won))",
  closed_lost: "hsl(var(--status-lost))",
};
const DEFAULT_FILL = "hsl(var(--accent))";

export function DealStageBarChart({ data }: { data: StageBucket[] }) {
  if (data.length === 0 || data.every((d) => d.count === 0)) {
    return (
      <div className="flex h-[260px] items-center justify-center rounded-md border border-dashed bg-muted/20 text-xs text-muted-foreground">
        No deal activity in this window.
      </div>
    );
  }
  return (
    <div className="h-[260px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
        >
          <CartesianGrid
            stroke="hsl(var(--border))"
            strokeDasharray="3 3"
            vertical={false}
          />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }}
            tickLine={false}
            axisLine={{ stroke: "hsl(var(--border))" }}
            interval={0}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }}
            tickLine={false}
            axisLine={false}
            width={28}
          />
          <Tooltip
            cursor={{ fill: "hsl(var(--muted))" }}
            contentStyle={{
              background: "hsl(var(--card))",
              border: "1px solid hsl(var(--border))",
              borderRadius: 8,
              fontSize: 12,
            }}
            labelStyle={{ color: "hsl(var(--muted-foreground))" }}
          />
          <Bar dataKey="count" radius={[6, 6, 0, 0]}>
            {data.map((d) => (
              <Bar
                key={d.stage_id}
                dataKey="count"
                fill={FILL[d.stage_id] ?? DEFAULT_FILL}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
